import { Link } from 'react-router-dom';
import { BookOpen } from 'lucide-react';

export const Legacy = () => {
  return (
    <div className="min-h-[calc(100vh-64px)]" data-testid="chapter-legacy">
      <article className="max-w-2xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <header className="mb-16 animate-fade-in">
          <p className="text-xs font-sans font-medium tracking-widest uppercase text-stone-400 mb-4">
            Chapter
          </p>
          <h1 className="font-serif font-light text-3xl md:text-4xl lg:text-5xl text-stone-800 tracking-tight leading-[1.2]">
            Legacy
          </h1>
        </header>

        <div className="prose-living space-y-8 animate-fade-in-delay-1">
          <p>
            Legacy is not only what you leave behind. 
            It's how you live while you're here.
          </p>

          <p>
            The way you treat people. The values you carry. 
            The moments that matter — whether anyone records them or not.
          </p>

          <p>
            This chapter is for those thinking about meaning — 
            not in a heavy way, but in a reflective one. 
            What matters to you? What would you want others to remember?
          </p>

          <div className="py-8 border-t border-b border-stone-100 my-12 space-y-6">
            <h2 className="font-serif text-xl text-stone-700">
              Questions about continuity:
            </h2>
            <ul className="space-y-4 text-stone-600">
              <li className="flex items-start gap-3">
                <span className="text-primary mt-1.5">—</span>
                <span>What values do you hope to pass on?</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary mt-1.5">—</span>
                <span>What stories would you want remembered?</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary mt-1.5">—</span>
                <span>What objects or traditions carry meaning for you?</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary mt-1.5">—</span>
                <span>If you could write a letter to the future, what would it say?</span>
              </li>
            </ul>
          </div>

          <p>
            Legacy isn't about being remembered by everyone. 
            It's about being understood by those who matter.
          </p>

          <p>
            This space is for thinking about what continues — 
            long after the moment has passed.
          </p>
        </div>

        <nav className="mt-16 pt-8 border-t border-stone-100 animate-fade-in-delay-2">
          <p className="text-sm font-sans text-stone-400 mb-4">Explore other chapters</p>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/living-book/chapters/longevity"
              className="inline-flex items-center gap-2 px-4 py-2 bg-stone-100 hover:bg-stone-200 rounded-full text-sm font-sans text-stone-600 transition-colors"
              data-testid="chapter-link-longevity"
            >
              <BookOpen className="w-4 h-4" strokeWidth={1.5} />
              Longevity
            </Link>
            <Link
              to="/living-book/chapters/responsibility"
              className="inline-flex items-center gap-2 px-4 py-2 bg-stone-100 hover:bg-stone-200 rounded-full text-sm font-sans text-stone-600 transition-colors"
              data-testid="chapter-link-responsibility"
            >
              <BookOpen className="w-4 h-4" strokeWidth={1.5} />
              Responsibility
            </Link>
            <Link
              to="/living-book/chapters/youre-not-behind"
              className="inline-flex items-center gap-2 px-4 py-2 bg-stone-100 hover:bg-stone-200 rounded-full text-sm font-sans text-stone-600 transition-colors"
              data-testid="chapter-link-youre-not-behind"
            >
              <BookOpen className="w-4 h-4" strokeWidth={1.5} />
              You're Not Behind
            </Link>
          </div>
        </nav>
      </article>
    </div>
  );
};

export default Legacy;
